"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var live_statuses_1 = require("@wix/wix-vod-constants/dist/common/live-statuses");
var lodash_1 = require("lodash");
var item_type_1 = require("@wix/wix-vod-constants/dist/api-types/enums/item-type");
var getStreamStatus = function (mediaInfo) {
    return lodash_1.get(mediaInfo, 'fileOutput.video[0].status');
};
exports.isScheduledLive = function (_a) {
    var itemType = _a.itemType;
    return itemType && itemType === item_type_1.ItemType.ItemScheduled;
};
exports.isStreamingLive = function (_a) {
    var itemType = _a.itemType;
    return itemType === item_type_1.ItemType.ItemLive;
};
exports.isFinalizingLive = function (_a) {
    var itemType = _a.itemType;
    return itemType === item_type_1.ItemType.ItemLiveFinalize;
};
exports.isPendingLiveStream = function (videoItem) {
    return exports.isStreamingLive(videoItem) &&
        getStreamStatus(videoItem.mediaInfo) === live_statuses_1.STREAM_STATUSES.PENDING;
};
exports.isReadyLiveStream = function (videoItem) {
    return exports.isStreamingLive(videoItem) &&
        getStreamStatus(videoItem.mediaInfo) === live_statuses_1.STREAM_STATUSES.READY;
};
//# sourceMappingURL=live.js.map